import { Checkbox } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid-premium";

export const EnableCell = (params: GridRenderCellParams<any>) => {
  return <Checkbox checked={params?.value ?? false} disabled />;
};
